/* eslint-disable */
import { useState, useEffect } from 'react'
import { mockUsers } from '../../lib/stories-data'
import { StoriesViewer } from './StoriesViewer'

export function StoriesFeed({ autoOpen = false, onClose: onParentClose }) {
    const [selectedUserIndex, setSelectedUserIndex] = useState(null)
    const [viewedUsers, setViewedUsers] = useState(new Set())

    useEffect(() => {
        if (autoOpen && mockUsers.length > 0 && selectedUserIndex === null) {
            setSelectedUserIndex(0)
            setViewedUsers(prev => new Set([...prev, mockUsers[0].id]))
        }
    }, [autoOpen, selectedUserIndex])

    const selectedUser = selectedUserIndex !== null ? mockUsers[selectedUserIndex] : null

    const handleSelectUser = (index) => {
        setSelectedUserIndex(index)
        setViewedUsers(prev => new Set([...prev, mockUsers[index].id]))
    }

    const handleCloseStories = () => {
        setSelectedUserIndex(null)
        // If parent provided onClose callback, call it to hide the entire StoriesFeed
        if (onParentClose) {
            onParentClose()
        }
    }

    const handleNextUser = () => {
        if (selectedUserIndex !== null && selectedUserIndex < mockUsers.length - 1) {
            handleSelectUser(selectedUserIndex + 1)
        } else {
            // All users viewed, close everything
            handleCloseStories()
        }
    }

    const handlePrevUser = () => {
        if (selectedUserIndex !== null && selectedUserIndex > 0) {
            handleSelectUser(selectedUserIndex - 1)
        }
    }

    return (
        <div className='relative bottom-0 left-0 z-50'>


            {/* Stories viewer modal */}
            {selectedUser && (
                <StoriesViewer
                    user={selectedUser}
                    isOpen={selectedUserIndex !== null}
                    onClose={handleCloseStories}
                    onNextUser={handleNextUser}
                    onPrevUser={handlePrevUser}
                />
            )}


        </div>
    )
}
